import type { RelatorioFiltro } from "@/api/escala.service";

// Competência default de toda aba de relatório: mês corrente, sem loja nem
// cargo escolhidos. Extraído pra não repetir `new Date()` em cada aba.
export function competenciaAtual(): RelatorioFiltro {
  const hoje = new Date();
  return { ano: hoje.getFullYear(), mes: hoje.getMonth() + 1 };
}
